import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Oval } from "react-loader-spinner";
import { FiMail } from "react-icons/fi"; // For a mail icon
import { StandardURL } from "../App";


const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const response = await axios.post(
        `${StandardURL}/iNyumba/auth/forgot-pwd`,
        { email }
      );
      toast.success(response.data.response);
      navigate("/"); // Redirect to login after successful request
    } catch (error) {
      toast.error(error.response?.data?.response || "An unexpected error occurred.");
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-500 to-indigo-600 p-4">
      <div className="max-w-md w-full bg-white rounded-xl shadow-2xl p-8 space-y-8 transform transition-all duration-300 hover:scale-105">
        <div className="text-center">
          <img
            className="mx-auto h-16 w-auto mb-4"
            src="https://www.dropbox.com/scl/fi/5qeolvr9hnmg7amue63up/inyumbatwo.png?rlkey=am75yoke6inayof82d6xckeiv&raw=1"
            alt="iNyumba Logo"
          />
          <h2 className="text-4xl font-extrabold text-gray-900 leading-tight">
            Forgot Password?
          </h2>
          <p className="mt-2 text-lg text-gray-600">
            Enter your email to reset it.
          </p>
        </div>
        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label htmlFor="email" className="sr-only">
              Email address
            </label>
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <FiMail className="h-5 w-5 text-gray-400" aria-hidden="true" />
              </div>
              <input
                id="email"
                name="email"
                type="email"
                autoComplete="email"
                required
                className="pl-10 appearance-none block w-full px-3 py-3 border border-gray-300 rounded-lg shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm transition duration-150 ease-in-out"
                placeholder="Email address"
                value={email}
                onChange={handleChange}
                disabled={isLoading}
              />
            </div>
          </div>

          <div>
            <button
              type="submit"
              disabled={isLoading}
              className={`w-full flex justify-center py-3 px-4 border border-transparent rounded-lg shadow-sm text-lg font-medium text-white transition duration-200 ease-in-out 
                ${
                  isLoading
                    ? "bg-indigo-400 cursor-not-allowed"
                    : "bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                }`}
            >
              {isLoading ? (
                <Oval
                  height={24}
                  width={24}
                  color="white"
                  visible={true}
                  ariaLabel="loading-indicator"
                  secondaryColor="rgba(255,255,255,0.4)"
                  strokeWidth={5}
                  strokeWidthSecondary={5}
                />
              ) : (
                "Send Reset Link"
              )}
            </button>
          </div>
        </form>
        <div className="text-center">
          <p className="text-sm text-gray-600">
            Remember your password?{" "}
            <button
              onClick={() => navigate("/")}
              className="font-medium text-indigo-600 hover:text-indigo-500 focus:outline-none focus:underline"
            >
              Log in here
            </button>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;